module.exports = __webpack_public_path__ + "img/JopieGerritsen_schommel_600x600px.1e2fab38.png";